import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import DateInput from 'src/app/components/DateInput';
import inputPropTypes from 'src/app/propTypes/input';
import Checkbox from 'src/app/components/Checkbox';
import {
  experienceDateToBlur,
  experienceDateToChange,
  experienceDateToDisable,
  experienceDateToFocus
} from 'src/app/redux/actions/registration/experience/experienceDateTo';
import { experienceDateFromBlur } from 'src/app/redux/actions/registration/experience/experienceDateFrom';


class ExperienceDatesToContainer extends React.Component {

  state = {
    stillWorking: false
  };

  resetDatesFromValidation = () => {
    const { dispatch, dateFrom, dateFromInputRef, disabled } = this.props;
    const { element } = dateFromInputRef.current;
    const date = '';

    if (element.checkValidity()) {
      const validationMessage = '';
      dispatch(experienceDateFromBlur(validationMessage, dateFrom, date, disabled));
    } else {
      const { validationMessage } = element;
      dispatch(experienceDateFromBlur(validationMessage, dateFrom, date, disabled));
    }
  };

  toggleDateTo = () => {
    const { dispatch, inputRef } = this.props;
    const { stillWorking } = this.state;

    this.setState({ stillWorking: !stillWorking });
    dispatch(experienceDateToDisable(!stillWorking));
    inputRef.current.setRawValue('');
    this.resetDatesFromValidation();
  };

  onChange = ({ target }) => {
    const { dispatch, markedAsWrong, apiError } = this.props;
    const { value, validationMessage } = target;

    dispatch(experienceDateToChange({
      value,
      validationMessage,
      markedAsWrong,
      apiError
    }));
  };

  onFocus = () => {
    const { dispatch } = this.props;

    dispatch(experienceDateToFocus());
  };

  onBlur = ({ target }) => {
    const { dispatch, dateFromInputRef, value: date, dateFrom, disabled } = this.props;
    const { validationMessage } = target;
    const { current } = dateFromInputRef;

    dispatch(experienceDateToBlur(validationMessage, date, dateFrom));
    dispatch(experienceDateFromBlur(current.element.validationMessage, dateFrom, date, disabled));
  };


  render() {
    const { stillWorking } = this.state;
    const { onChange, onFocus, onBlur, toggleDateTo } = this;
    const {
      value,
      validationMessage,
      markedAsWrong,
      focus,
      apiError,
      disabled,
      inputRef,
      hasWorkExperience,
      sending
    } = this.props;


    return (
      <React.Fragment>
        <DateInput label="Do"
                   ref={ inputRef }
                   required={ hasWorkExperience || !stillWorking }
                   disabled={ !hasWorkExperience || disabled || sending }
                   pattern=".{7}"
                   data-test="input-date-to"
                   { ...{
                     value,
                     validationMessage,
                     markedAsWrong,
                     focus,
                     apiError,
                     onChange,
                     onFocus,
                     onBlur
                   } }
        />

        <Checkbox
          checked={ stillWorking }
          onClick={ toggleDateTo }
          disabled={ !hasWorkExperience }
          data-test="checkbox-still-working"
        >
          Nadal pracuję
        </Checkbox>

      </React.Fragment>
    );
  }
}

ExperienceDatesToContainer.propTypes = {
  sending: PropTypes.bool.isRequired,
  hasWorkExperience: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  inputRef: PropTypes.object.isRequired,
  ...inputPropTypes
};

const mapStateToProps = (store) => ({
  ...store.experienceDateToReducer,
  ...store.experienceFormReducer,
  dateFrom: store.experienceDateFromReducer.value
});

export default connect(mapStateToProps)(ExperienceDatesToContainer);
